var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popup-overlay" }, [
    _c("div", { staticClass: "top-bar" }, [
      _c(
        "button",
        { staticClass: "close-button", on: { click: _vm.handleClose } },
        [_c("InlineSvg", { attrs: { src: "/images/icons-2025/x-close.svg" } })],
        1
      ),
      _vm._v(" "),
      _vm.imageType === "marketing-post"
        ? _c("div", { staticClass: "action-buttons" }, [
            _c(
              "button",
              {
                staticClass: "share-button",
                attrs: { disabled: !_vm.imageLoaded || _vm.imageError },
                on: { click: _vm.onShare }
              },
              [
                _c("InlineSvg", {
                  attrs: { src: "/images/icons-2025/share.svg" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "download-button",
                attrs: { disabled: !_vm.imageLoaded || _vm.imageError },
                on: { click: _vm.onDownload }
              },
              [
                _c("InlineSvg", {
                  attrs: { src: "/images/icons-2025/download.svg" }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "image-container" }, [
      _c("img", {
        staticClass: "chat-image",
        attrs: { src: _vm.imageSrc, alt: _vm.imageAlt || "Chat image" },
        on: { load: _vm.onImageLoad, error: _vm.onImageError }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }